import { useCallback, useState } from 'react';

import { Menus } from '../types';

/**
 * Use this method to handle form tab errors.
 */
export const useTabErrors = () => {
    const [tabErrors, setTabErrors] = useState<Record<Menus, boolean>>({
        settings: false,
        inputVariables: false,
    });

    const onErrorChange = useCallback(
        (key: keyof typeof tabErrors) => (hasErrors: boolean) => {
            // The condition aims to avoid infinite loops
            if (tabErrors[key] !== hasErrors) {
                setTabErrors((prev) => ({
                    ...prev,
                    [key]: hasErrors,
                }));
            }
        },
        [tabErrors],
    );

    const hasTabError = Object.values(tabErrors).some(Boolean);

    return {
        hasTabError,
        onErrorChange,
        tabErrors,
    };
};
